import { RangeControl } from "@wordpress/components";
import { __ } from "@wordpress/i18n";

/**
 * Per-breakpoint column counts, shared by the loop parent blocks
 * (brandy/product-collection, brandy/posts).
 *
 * The same three numbers are the slides per view in slider mode — one control
 * set drives both, which is why the labels switch instead of the controls. The
 * ceilings match the clamps in Helpers/LoopLayout::columns().
 *
 * The two modes genuinely change at different widths, so the help text does
 * too: the grid's breakpoints live in each template block's stylesheet
 * (780/480), the slider's in embla.min.css (480-1023 / 479). Stating the wrong
 * pair sent authors looking for a bug where there was only a second breakpoint.
 */
export default function LoopColumnsControls({
  displayLayout = {},
  updateLayout,
  isSlider = false,
}) {
  return (
    <>
      <RangeControl
        __nextHasNoMarginBottom
        __next40pxDefaultSize
        label={
          isSlider
            ? __("Slides per view (desktop)", "brandy-blocks")
            : __("Columns (desktop)", "brandy-blocks")
        }
        value={displayLayout.columns ?? 4}
        min={1}
        max={8}
        onChange={(value) => updateLayout({ columns: value })}
      />
      <RangeControl
        __nextHasNoMarginBottom
        __next40pxDefaultSize
        label={
          isSlider
            ? __("Slides per view (tablet)", "brandy-blocks")
            : __("Columns (tablet)", "brandy-blocks")
        }
        help={
          isSlider
            ? __("Applied from 480px to 1023px.", "brandy-blocks")
            : __("Applied at 780px and below.", "brandy-blocks")
        }
        value={displayLayout.columnsTablet ?? 2}
        min={1}
        max={6}
        onChange={(value) => updateLayout({ columnsTablet: value })}
      />
      <RangeControl
        __nextHasNoMarginBottom
        __next40pxDefaultSize
        label={
          isSlider
            ? __("Slides per view (mobile)", "brandy-blocks")
            : __("Columns (mobile)", "brandy-blocks")
        }
        help={
          isSlider
            ? __("Applied at 479px and below.", "brandy-blocks")
            : __("Applied at 480px and below.", "brandy-blocks")
        }
        value={displayLayout.columnsMobile ?? 1}
        min={1}
        max={4}
        onChange={(value) => updateLayout({ columnsMobile: value })}
      />
    </>
  );
}
